module.exports = __webpack_public_path__ + "static/media/8_The final lesson_SE.2f23a7e7.txt";